import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AdminAuthService } from '../services/admin-auth.service';
import { PERMISOS_BASE, SeccionAdmin } from '../services/mock-data.service';

export function roleGuard(seccion: SeccionAdmin): CanActivateFn {
  return () => {
    const auth   = inject(AdminAuthService);
    const router = inject(Router);
    const rol    = auth.currentUser()?.rol;
    if (!rol) return router.createUrlTree(['/login']);
    if (!PERMISOS_BASE[rol].includes(seccion)) return router.createUrlTree(['/dashboard']);
    return true;
  };
}
